// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/cssWithMappingToString.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "._ZamKbQy_nRecLYJ66qG{display:flex;width:3.5em;height:3.5em}._ZamKbQy_nRecLYJ66qG.Dh53lXw8qN77uVqug2Bh{width:2.3125em;height:2.3125em}", "",{"version":3,"sources":["webpack://./src/Components/HeroTrophy/styles.module.scss"],"names":[],"mappings":"AAAA,sBACE,YAAA,CAEA,WAAA,CACA,YAAA,CAEA,2CACE,cAAA,CACA,eAAA","sourcesContent":[".root {\n  display: flex;\n\n  width: 3.5em;\n  height: 3.5em;\n\n  &.small {\n    width: 2.3125em;\n    height: 2.3125em;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"root": "_ZamKbQy_nRecLYJ66qG",
	"small": "Dh53lXw8qN77uVqug2Bh"
};
export default ___CSS_LOADER_EXPORT___;
